import { render, staticRenderFns } from "./CheckDocuments.vue?vue&type=template&id=44ff50e4&"
import script from "./CheckDocuments.vue?vue&type=script&lang=ts&"
export * from "./CheckDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports